import { render, staticRenderFns } from "./crewDetail.vue?vue&type=template&id=92a25ee4&scoped=true"
import script from "./crewDetail.vue?vue&type=script&lang=js"
export * from "./crewDetail.vue?vue&type=script&lang=js"
import style0 from "./crewDetail.vue?vue&type=style&index=0&id=92a25ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a25ee4",
  null
  
)

export default component.exports